import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle, Download } from 'lucide-react';

export interface PaymentBulkActionsProps {
  selectedCount: number;
  bulkMarkingPaid: boolean;
  onBulkMarkPaid: () => void;
  onBulkExport: () => void;
  onSendReminder?: () => void;
}

export const PaymentBulkActions: React.FC<PaymentBulkActionsProps> = ({
  selectedCount,
  bulkMarkingPaid,
  onBulkMarkPaid,
  onBulkExport,
}) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm text-blue-800">
          {selectedCount} payment(s) selected
        </span>
        <div className="flex items-center space-x-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onBulkMarkPaid}
            disabled={bulkMarkingPaid}
          >
            <CheckCircle className="w-3 h-3 mr-1" />
            {bulkMarkingPaid ? 'Updating...' : 'Mark as Paid'}
          </Button>
          <Button size="sm" variant="outline" onClick={onBulkExport}>
            <Download className="w-3 h-3 mr-1" />
            Export Selected
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentBulkActions;
